import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-spinner-full-block",
  templateUrl: "./spinner-full-block.component.html",
})
export class SpinnerFullBlockComponent implements OnInit {
  @Input() message: string = "";
  constructor() {}

  ngOnInit(): void {}
}
